import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { KineticHeading } from "@/components/common/KineticHeading";

// Shared subpage header banner. Optional background image for a bit of
// visual texture on content-heavy pages.
export const PageHero = ({ eyebrow, title, subtitle, crumbLabel, backgroundImage, backgroundAlt }) => (
  <section data-testid="page-hero" className="relative overflow-hidden bg-brand-black py-28 md:py-36">
    {backgroundImage && (
      <div className="absolute inset-0 z-0">
        <img src={backgroundImage} alt={backgroundAlt || ""} className="h-full w-full object-cover opacity-25" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-brand-black/80 to-brand-black/50" />
      </div>
    )}
    <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-12">
      <nav aria-label="Breadcrumb" className="mb-6 flex items-center gap-1.5 text-xs uppercase tracking-widest text-white/40">
        <Link to="/" data-testid="breadcrumb-home-link" className="hover:text-white transition-colors">
          Home
        </Link>
        <ChevronRight className="h-3 w-3" />
        <span className="text-white/70">{crumbLabel || title}</span>
      </nav>
      {eyebrow && <p className="mb-4 font-subheading text-xs font-semibold uppercase tracking-[0.3em] text-brand-purple">{eyebrow}</p>}
      <h1 className="font-heading text-6xl uppercase leading-[1.05] text-white sm:text-7xl">
        <KineticHeading lines={[title]} />
      </h1>
      {subtitle && <p className="mt-6 max-w-xl text-base text-white/60">{subtitle}</p>}
    </div>
  </section>
);
